
import { createAction, props } from "@ngrx/store";

import { FeatureType, FilterModel, FilterProfiles, SourceTypeDetails } from "../generated";


export const setFilterProfilesAsJson = createAction(
  '[Shared] SET_FILTER_PROFILES_AS_JSON',
  props<{ filterProfilesAsJson: string | null }>()
);

export const getAllFilterProfiles = createAction(
  '[Shared] GET_ALL_FILTER_PROFILES',
  props<{ filterType: string }>()
);
export const getAllFilterProfilesSuccess = createAction(
  '[Shared] GET_ALl_FILTER_PROFILES_SUCCESS',
  props<{ filterProfiles: FilterProfiles[] }>()
);
export const getAllFilterProfilesError = createAction(
  '[Shared] GET_ALL_FILTER_PROFILES_ERROR',
  props<{ payload: any }>()
);

export const postCreateProfile = createAction(
  '[Shared] POST_CREATE_PROFILE',
  props<{ filterModel: FilterModel }>()
);
export const postCreateProfileSuccess = createAction(
  '[Shared] POST_CREATE_PROFILE_SUCCESS'
);
export const postCreateProfileError = createAction(
  '[Shared] POST_CREATE_PROFILE_ERROR',
  props<{ payload: number }>()
);

export const putUpdateFilter = createAction(
  '[Shared] PUT_UPDATE_PROFILE',
  props<{ id: number, filterModel: FilterModel }>()
);
export const putUpdateFilterSuccess = createAction(
  '[Shared] PUT_UPDATE_PROFILE_SUCCESS'
);
export const putUpdateFilterError = createAction(
  '[Shared] PUT_UPDATE_PROFILE_ERROR',
  props<{ payload: number }>()
);

export const deleteFilter = createAction(
  '[Shared] DELETE_PROFILE',
  props<{ id: number }>()
);
export const deleteFilterSuccess = createAction(
  '[Shared] DELETE_PROFILE_SUCCESS'
);
export const deleteFilterError = createAction(
  '[Shared] DELETE_PROFILE_ERROR',
  props<{ payload: number }>()
);

export const getSourceTypes = createAction(
  '[Shared] GET_SOURCE_TYPES'
);
export const getSourceTypesSuccess = createAction(
  '[Shared] GET_SOURCE_TYPES_SUCCESS',
  props<{ sourceTypes: SourceTypeDetails[] }>()
);
export const getSourceTypesError = createAction(
  '[Shared] GET_SOURCE_TYPES_ERROR',
  props<{ payload: any }>()
);

export const getFeatureTypes = createAction(
  '[Shared] GET_FEATURE_TYPES'
);
export const getFeatureTypesSuccess = createAction(
  '[Shared] GET_FEATURE_TYPES_SUCCESS',
  props<{ featureTypes: FeatureType[] }>()
);
export const getFeatureTypesError = createAction(
  '[Shared] GET_FEATURE_TYPES_ERROR',
  props<{ payload: any }>()
);

export const SharedActions = {
  setFilterProfilesAsJson,
  getAllFilterProfiles, getAllFilterProfilesSuccess, getAllFilterProfilesError,
  putUpdateFilter, putUpdateFilterSuccess, putUpdateFilterError,
  postCreateProfile, postCreateProfileSuccess, postCreateProfileError,
  deleteFilter, deleteFilterSuccess, deleteFilterError,
  getSourceTypes, getSourceTypesSuccess, getSourceTypesError,
  getFeatureTypes, getFeatureTypesSuccess, getFeatureTypesError
}
